import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function Testimonials() {
  const testimonials = [{
    name: 'Martín G.',
    age: 28,
    city: 'CABA',
    quote: 'Arranqué el protocolo sin mucha fe porque ya había probado de todo. Al día 25 noté que el desagüe tenía la mitad de pelos que antes. Hoy voy por el día 70 y mi vieja me dijo que se me ve más pelo en la coronilla. No lo puedo creer.',
    img: 'https://cdn.magicpatterns.com/uploads/qDhvTNyfrowucACUhag57o/tesmono_2.png'
  }, {
    name: 'Facundo R.',
    age: 34,
    city: 'Córdoba',
    quote: 'Lo que más me sorprendió es lo del cuero cabelludo. Antes lo tenía duro como una piedra. Después de 3 semanas de masajes del Tomo 4, la piel se mueve. Es una sensación completamente diferente. Y el pelo tiene más cuerpo, se nota.',
    img: 'https://cdn.magicpatterns.com/uploads/eKXYPguoNzFaHxxNjDnRUW/testimono_6.png'
  }, {
    name: 'Nicolás T.',
    age: 31,
    city: 'Rosario',
    quote: 'Usé Minoxidil 2 años y me tenía harto la irritación. Empecé el Megakit como alternativa y en 60 días tengo vellos nuevos en las entradas que no tenía. Estoy dejando el Minoxidil gradualmente como dice el sistema.',
    img: 'https://cdn.magicpatterns.com/uploads/tsMtpyUseYJH6J6YCnorA9/tertimono_3.png'
  }, {
    name: 'Sebastián L.',
    age: 26,
    city: 'Mendoza',
    quote: 'Tengo 26 y ya se me estaban yendo las entradas. Mi viejo es pelado y pensé que no había vuelta atrás. El tónico de romero concentrado del Tomo 2 es otra cosa comparado con lo que había probado antes. Van 45 días y la caída bajó muchísimo.',
    img: 'https://cdn.magicpatterns.com/uploads/t2YX9gk9ue7CbMxpRPugME/testimono_5.png'
  }, {
    name: 'Tomás D.',
    age: 38,
    city: 'Mar del Plata',
    quote: 'A los 38 ya estaba resignado. Un amigo me pasó el Megakit y dije bueno, última oportunidad. El licuado del Tomo 5 es un golazo, y los tónicos se preparan en 20 minutos. Voy por el día 80 y las fotos comparativas no mienten. Hay diferencia real.',
    img: 'https://cdn.magicpatterns.com/uploads/jjF72gSR6teVix2DSN682j/testimono_4.png'
  }];
  return <section className="py-16 md:py-24 px-4 bg-gray-50 border-t border-gray-200" data-id="element-288">
      <div className="max-w-5xl mx-auto" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-290">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-291">
            PIBES QUE YA TOMARON EL CONTROL
          </h2>
          <p className="text-gray-500 text-lg" data-id="element-292">
            Resultados reales de usuarios del Sistema Megakit
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-293">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className={`bg-white rounded-lg border border-gray-200 flex flex-col shadow-sm overflow-hidden ${idx === 4 ? 'md:col-span-2 lg:col-span-1 md:w-1/2 lg:w-full md:mx-auto' : ''}`} data-id="element-294">
              {t.img && <img src={t.img} alt={`Resultado de ${t.name}`} className="w-full h-48 object-cover" data-id="element-295" />}
              <div className="p-6 flex flex-col flex-grow" data-id="element-296">
                <div className="flex text-gold mb-4 text-sm" data-id="element-297">★★★★★</div>
                <p className="text-gray-600 italic mb-6 flex-grow" data-id="element-298">
                  "{t.quote}"
                </p>
                <div className="mt-auto pt-4 border-t border-gray-200" data-id="element-299">
                  <p className="font-bold text-gray-900" data-id="element-300">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-301">
                    {t.age} años | {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-302">
          <CTAButton data-id="element-303">EMPEZAR MI PROTOCOLO HOY</CTAButton>
        </div>
      </div>
    </section>;
}